import axios from "axios";
import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

const getSections = async () => {

  const url = `${ baseUrl }/section`;

  const token = await authHeader();

  return axios
    .get(url,
      {
          headers: token 
      }
    )
    .then(response => {
      return response.data;
     }
     )
};

const getCreateSection = async (param) => {

  const url = `${ baseUrl }/section/create`;

  const token = await authHeader();

  return axios
    .post(url,
      {
        name: param
      },
      {
          headers: token 
      }
    )
    .then(response => {
      return response.data;
     }
     )
};

const deleteSection = async(id) => {

  const url = `${ baseUrl }/section/delete/${id}`;
  const token = await authHeader();

  return axios.delete(url,
    {
      headers: token 
    }
    ).then(
        (response) => {
      return response.data;
    });
};

const getUpdateSection = async (data) =>{

  const param = {
    'id':data.id,
    'name':data.section
  }
  const url = `${ baseUrl }/section/modify`;

  const token = await authHeader();

  return axios
    .put(url,
        param,
      {
          headers: token 
      }
    )
    .then(response => {
      return response.data;
     }
     )

};

const getCreateContent = async (data) =>{

const dataContent = {
  'section' : data.section,
  'name': data.nameContent,
  'document': data.file

};

const url = `${ baseUrl }/document/create`;

const token = await authHeader();

return axios
  .post(url,
    
        dataContent
    ,
    {
        headers: token 
    }
  )
  .then(response => {
    return response.data;
   }
   )

}

const getUpdateContent = async (data) =>{

  const dataContent = {
    'id':data.id,
    'section' : data.section,
    'name': data.nameContent,
    'document': data.file
  
  };
const url = `${ baseUrl }/document/modify`;

const token = await authHeader();

return axios
  .put(url,
        dataContent
    ,
    {
        headers: token 
    }
  )
  .then(response => {
    return response.data;
   }
   )

}

const getContents = async () => {

  const url = `${ baseUrl }/document`;

  const token = await authHeader();

  return axios
    .get(url,
      {
          headers: token 
      }
    )
    .then(response => {
      return response.data;
     }
     )
};

const deleteFile = async(fileId) => {

  const url = `${ baseUrl }/document/delete/${fileId}`;
  const token = await authHeader();

  return axios.delete(url,
    {
      headers: token 
    }
    ).then(
        (response) => {
      return response.data;
    });
};

const getFileByName = async(fileId) =>{

  const url = `${ baseUrl }/document/get/${fileId}`;

  const token = await authHeader();

  return axios
    .get(url,
      {
          headers: token 
      }
    )
    .then(response => {
      return response.data;
     }
     )

}

  export default {
    getCreateSection,
    getCreateContent,
    getUpdateContent,
    getUpdateSection,
    getSections,
    getContents,
    getFileByName,
    deleteFile,
    deleteSection
}